<h2 mat-dialog-title>{{title}}</h2>

<mat-dialog-content *ngIf="viewMode == 'translations'">

    <sprout-form-upload *ngIf="!fileImportTO" (fileImportTOEventEmitter)="setFileImportTO($event)"></sprout-form-upload>

    <div class="alert alert-info" *ngIf="fileImportTO">Importing translations...please wait...</div>


    <button mat-button mat-raised-button color="accent" (click)="onExportTranslations()">Export</button>

</mat-dialog-content>

<!--<mat-dialog-content [formGroup]="languagesForm" *ngIf="viewMode == 'languages'">-->
<mat-dialog-content *ngIf="viewMode == 'languages'">

    <div class="example-container mat-elevation-z8">
        <mat-table #table [dataSource]="dataSource">

            <!--- Note that these columns can be defined in any order.
                  The actual rendered columns are set as a property on the row definition" -->

            <!-- Checked Column -->
            <ng-container matColumnDef="checked">
                <mat-header-cell *matHeaderCellDef></mat-header-cell>
                <mat-cell *matCellDef="let i = index">
<!--                    <mat-checkbox [(ngModel)]="locales[i].checked" ></mat-checkbox>-->
<!--                    <mat-checkbox [ngModel]="locales[i].checked" (ngModelChange)="onLanguageChange(locales[i])"></mat-checkbox>-->
                    <mat-checkbox [(ngModel)]="locales[i].checked" (ngModelChange)="onLanguageChange(locales[i])"></mat-checkbox>
<!--                    <mat-checkbox [formControlName]="i"></mat-checkbox>-->
<!--                    <mat-checkbox [formControlName]="i"></mat-checkbox>-->
<!--                    <mat-checkbox [formControl]="languageFormArray.controls[i]['checked']"></mat-checkbox>-->
<!--                    <mat-checkbox [formControl]="languageFormArray.controls['checked'][i]"></mat-checkbox>-->
<!--                    <mat-checkbox [formControl]="languagesForm.controls['checked'][i]"></mat-checkbox>-->
<!--                    <mat-checkbox [formControl]="locale.get('checked')"></mat-checkbox>-->
                </mat-cell>
            </ng-container>

            <!-- Code Column -->
            <ng-container matColumnDef="code">
                <mat-header-cell *matHeaderCellDef> Language </mat-header-cell>
                <mat-cell style="width: 100%" *matCellDef="let i = index"> {{locales[i].name}} ({{locales[i].code}}) </mat-cell>
            </ng-container>

            <!-- Name Column -->
<!--            <ng-container matColumnDef="name">-->
<!--                <mat-header-cell *matHeaderCellDef> Name </mat-header-cell>-->
<!--                <mat-cell *matCellDef="let i = index"> {{locales[i].name}} </mat-cell>-->
<!--            </ng-container>-->

            <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{hovered: row.hovered, highlighted: row.highlighted}" (click)="row.highlighted = !row.highlighted" (mouseover)="row.hovered = true" (mouseout)="row.hovered = false"></mat-row>
        </mat-table>
    </div>

</mat-dialog-content>

<!--<mat-dialog-actions align="end">-->
<mat-dialog-actions>
    <button *ngIf="viewMode == 'translations'" mat-button mat-raised-button color="accent" (click)="onPickLanguages()" style="float: left">Languages</button>
    <button *ngIf="viewMode == 'languages'" mat-button mat-raised-button color="accent" (click)="onTranslations()" style="float: left">Translations</button>
    <button *ngIf="viewMode == 'translations'" mat-button (click)="close()">Close</button>
    <div *ngIf="viewMode == 'translations'" fxFlex></div>
    <button *ngIf="viewMode == 'translations'" mat-button mat-raised-button color="primary" [disabled]="translationsForm.invalid" (click)="save()">Save</button>
</mat-dialog-actions>